import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=6d00b546&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"
import style0 from "./Sign.vue?vue&type=style&index=0&id=6d00b546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d00b546",
  null
  
)

export default component.exports